import { normalizeUnifiedAssistantResponseEnvelope } from '../../shared/assistantResponseEnvelope';
import type {
  AdmissionsAIContextualAction,
  AdmissionsAIDebugMetadata,
  AdmissionsAIResponse,
  AdmissionsAssistantPresentationDiagnostics,
  AdmissionsCitation,
} from './types';

export const coercePresentationDiagnosticsFromDebug = (
  debug: AdmissionsAIDebugMetadata | null | undefined,
): AdmissionsAssistantPresentationDiagnostics | null => {
  const candidate = debug?.presentationDiagnostics;
  if (!candidate || typeof candidate !== 'object' || Array.isArray(candidate)) {
    return null;
  }
  const reasonCode = candidate.reasonCode;
  if (reasonCode !== 'machine_payload_sanitized' && reasonCode !== 'machine_payload_blocked') {
    return null;
  }
  const title = typeof candidate.title === 'string' ? candidate.title.trim() : '';
  const summary = typeof candidate.summary === 'string' ? candidate.summary.trim() : '';
  if (!title || !summary) {
    return null;
  }
  return {
    reasonCode,
    title,
    summary,
    operatorGuidance: typeof candidate.operatorGuidance === 'string' ? candidate.operatorGuidance.trim() || null : null,
    module: typeof candidate.module === 'string' ? candidate.module.trim() || null : null,
    targetRoute: typeof candidate.targetRoute === 'string' ? candidate.targetRoute.trim() || null : null,
    displayMode: candidate.displayMode === 'icon' ? 'icon' : candidate.displayMode === 'drawer' ? 'drawer' : undefined,
  };
};

export const sanitizeAdmissionsAIResponseForPresentation = (input: {
  response: AdmissionsAIResponse;
  module?: string | null;
}): {
  answer: string;
  citations: AdmissionsCitation[];
  actions: AdmissionsAIContextualAction[];
  debug: AdmissionsAIDebugMetadata | null;
  module: string;
  presentation: NonNullable<AdmissionsAIResponse['presentation']>;
  presentationDiagnostics: AdmissionsAssistantPresentationDiagnostics | null;
} => {
  const normalized = normalizeUnifiedAssistantResponseEnvelope({
    answer: input.response.answer,
    citations: input.response.citations,
    actions: input.response.actions ?? [],
    module: input.response.module ?? input.module ?? 'general',
    debug: input.response.debug,
    presentation: input.response.presentation,
  });

  return {
    answer: normalized.answer,
    citations: normalized.citations,
    actions: normalized.actions,
    debug: normalized.debug as AdmissionsAIDebugMetadata,
    module: normalized.module,
    presentation: normalized.presentation,
    presentationDiagnostics: normalized.presentationDiagnostics,
  };
};
